export const capabilities: string[] = [
    "Have instant runtime protection with our patented Exploitation Fingerprint™ technology",
    "Secure your firmware and third-party libraries during execution with less than 3% overhead",
    "Block attacks that exploit memory vulnerabilities, remote code executions, command injections and more",
    "Expedite root-cause analysis and bug resolution with detailed event timeline",
    "Achieve instant compliance (Dynamic SBOM, risk mitigations and more)",
];
